import { DropShadowName } from 'widgets/ImageWidget/ImageWidget.types';

export const DROP_SHADOW_CONFIG: Record<DropShadowName, (alpha: number) => string> = {
  None: () => '',
  Spread: (alpha: number = 50) => `drop-shadow(0 0 4px rgba(0, 0, 0, ${alpha / 100}))`,
  Drop: (alpha: number = 50) => `drop-shadow(5px 5px 5px rgba(0, 0, 0, ${alpha / 100}))`,
  Retro: (alpha: number = 50) => `drop-shadow(5px 5px 1px rgba(0, 0, 0, ${alpha / 100}))`,
};

export const DROP_SHADOW_LIST: Array<{ label: DropShadowName; filter: string; labeli18n: TemplateStringsArray }> = [
  // keyPrefix: 'imageToolbar' is required for labeli18n to be working properly
  // e.g, `useTranslation('editor_widget_toolbar', { keyPrefix: 'imageToolbar', useSuspense: false })`
  {
    label: 'None',
    filter: '',
    labeli18n: 'shadow.nameLabel.none' as unknown as TemplateStringsArray,
  },
  {
    label: 'Spread',
    filter: 'drop-shadow(0 0 4px rgba(0, 0, 0, 0.4));',
    labeli18n: 'shadow.nameLabel.spread' as unknown as TemplateStringsArray,
  },
  {
    label: 'Drop',
    filter: 'drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.4));',
    labeli18n: 'shadow.nameLabel.drop' as unknown as TemplateStringsArray,
  },
  {
    label: 'Retro',
    filter: 'drop-shadow(5px 5px 1px rgba(0, 0, 0, 0.4));',
    labeli18n: 'shadow.nameLabel.retro' as unknown as TemplateStringsArray,
  },
];
